import { render, staticRenderFns } from "./vx_datatable.vue?vue&type=template&id=5393c5ba&scoped=true&"
import script from "./vx_datatable.vue?vue&type=script&lang=js&"
export * from "./vx_datatable.vue?vue&type=script&lang=js&"
import style0 from "./vx_datatable.vue?vue&type=style&index=0&id=5393c5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393c5ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5393c5ba', component.options)
    } else {
      api.reload('5393c5ba', component.options)
    }
    module.hot.accept("./vx_datatable.vue?vue&type=template&id=5393c5ba&scoped=true&", function () {
      api.rerender('5393c5ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/vx_datatable.vue"
export default component.exports